import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MipdAdmissionTypeService {
  mipdAdmissionType: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mipd_admission_type/list/?';
  private DeListRecord = webapi + 'mipd_admission_type/deactivated_list/?';
  private AddRecord = webapi + 'mipd_admission_type/create';
  private EditRecord = webapi + 'mipd_admission_type/update';
  private GetRecord = webapi + 'mipd_admission_type/byid/';
  private DeleteRecord = webapi + 'mipd_admission_type/delete/';
  private ReActiveRecord = webapi + 'mipd_admission_type/reActive/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mipd-admission-type/mipd-admission-type.service.ts